import { render, staticRenderFns } from "./SettingsRegions.vue?vue&type=template&id=37b59a92"
import script from "./SettingsRegions.vue?vue&type=script&lang=js"
export * from "./SettingsRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports